import { SupplierDto } from "./useGetSuppliers";
import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";
import { HttpMethod } from "../../Common/useFetch";
import useUserRequest, { UserRequestSpec } from "../../Common/useUserRequest";
import { RequestOptions } from "../../Common/useRequest";

export type SupplierUpsertDto = Omit<SupplierDto, 'id'>;

const path = (businessId: string) => `/api/businesses/${businessId}/suppliers`;

const createSpec = (businessId: string): UserRequestSpec => ({
  path: path(businessId),
  method: HttpMethod.POST,
});

const updateSpec = (businessId: string, supplierId: string): UserRequestSpec => ({
  path: `${path(businessId)}/${supplierId}`,
  method: HttpMethod.PUT,
});

const useUpsertSupplier = (supplierId?: string, options?: RequestOptions<string>) => {
  const business = useSelectedBusiness();

  var spec = supplierId
    ? updateSpec(business.id, supplierId)
    : createSpec(business.id);

  return useUserRequest<SupplierUpsertDto, string>(spec, options);
}

export default useUpsertSupplier;
